import { Component, OnInit, Input, OnChanges, SimpleChange, Output, EventEmitter, OnDestroy } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ProductTypePipe } from "../../product-type.pipe";
import { NgbCarouselConfig } from "@ng-bootstrap/ng-bootstrap";
import * as echarts from "echarts";
import * as _ from "lodash";
import * as moment from "moment";
moment.locale("zh-tw");

import { Domain as WebsideDomain } from "../../../../../lib/Domain/Webside";
import { Domain as ProductDomain } from "../../../../../lib/Domain/Product";
import { Domain } from "../../../../../lib/Domain";

import { HttpService } from "../../http.service";

@Component({
    selector: "app-energy-storage-detail",
    templateUrl: "./energy-storage-detail.component.html",
    styleUrls: ["./energy-storage-detail.component.css"]
})
export class EnergyStorageDetailComponent implements OnInit, OnDestroy {

    constructor(private httpService: HttpService, config: NgbCarouselConfig) {
        config.interval = 5000;
    }
    @Input() Item: WebsideDomain.IProduct = undefined;
    @Input() Time: Date = new Date();
    private now = moment().format("YYYY-MM-DD");
    private hour_x = ["12am", "1am", "2am", "3am", "4am", "5am", "6am", "7am", "8am", "9am", "10am", "11am",
        "12pm", "1pm", "2pm", "3pm", "4pm", "5pm", "6pm", "7pm", "8pm", "9pm", "10pm", "11pm"];

    public gridpower_chart: echarts.EChartOption;
    public loadpower_chart: echarts.EChartOption;
    public battery_chart: echarts.EChartOption;
    public generator_chart: echarts.EChartOption;
    public rawdata: any[];
    public realtime = {
        loadpower: {
            voltage: 0,
            current: 0,
            watt: 0,
            kwh: 0,
        },
        gridpower: {
            voltage: 0,
            current: 0,
            watt: 0,
            kwh: 0,
        },
        battery: {
            voltage: 0,
            charge_current: 0,
            discharge_current: 0,
            charge_watt: 0,
            discharge_watt: 0,
            soc: 0,
        },
        generator: 0,
        inverter: 0,
        datestamp: "",
        AvailabilityEnergy: 0,
        AvailabilityHour: 0,
    };
    gridPowerChartOption = "watt";
    LoadPowerChartOption = "watt";
    BatteryOption = "voltage";
    private tempdata: any;
    private isTimer = false;
    ngOnInit() {
        this.isTimer = true;
        this.SetTimer();
    }
    ngOnDestroy() {
        this.isTimer = false;
    }
    private SetTimer() {
        const runGet = () => {
            setTimeout(async () => {
                if (this.Item) {
                    if (moment(this.Time).format("YYYY-MM-DD") === this.now) {
                        this.tempdata = await this.httpService.energystorageService.data(this.Item.uuid, this.Time);
                        this.process(this.tempdata);
                    }
                    this.rawdata = await this.httpService.energystorageService.rawdata(this.Item.uuid);
                }
                if (this.isTimer) {
                    runGet();
                }
            }, 60 * 1000);
        };
        if (this.isTimer) {
            runGet();
        }
    }

    async ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
        if (changes["Item"] && this.Item) {
            await this.onrefresh();
        } else if (changes["Time"] && this.Item) {
            try {
                this.tempdata = await this.httpService.energystorageService.data(this.Item.uuid, this.Time);
                this.process(this.tempdata);
            } catch (erro) {
                console.error(erro);
            }
        }
    }
    async setgridPowerChartOption(value: string) {
        this.gridPowerChartOption = value;
        this.process(this.tempdata);
    }
    async setLoadPowerChartOption(value: string) {
        this.LoadPowerChartOption = value;
        this.process(this.tempdata);
    }
    async setBatteryOption(value: string) {
        this.BatteryOption = value;
        this.process(this.tempdata);
    }
    public async onrefresh() {
        try {
            this.rawdata = await this.httpService.energystorageService.rawdata(this.Item.uuid);
            this.tempdata = await this.httpService.energystorageService.data(this.Item.uuid, this.Time);
            this.process(this.tempdata);
        } catch (erro) {
            console.error(erro);
        }
    }
    private process(item: WebsideDomain.IEnergyStorageSystem) {
        // 處理市電
        if (item.GridPower !== undefined && item.GridPower.length > 0) {
            item.GridPower = this.LoProlfieBlance(this.LoProlfieProcess(item.GridPower)); // _.sortBy(item.GridPower, "timestamp");
            this.realtime.gridpower.kwh = item.GridPower[item.GridPower.length - 1].kwha - item.GridPower[0].kwha;
            this.realtime.gridpower.voltage = item.GridPower[item.GridPower.length - 1].va;
            this.realtime.gridpower.current = item.GridPower[item.GridPower.length - 1].ia;
            this.realtime.gridpower.watt = item.GridPower[item.GridPower.length - 1].watt_a;
            this.realtime.datestamp = moment(item.GridPower[item.GridPower.length - 1].timestamp).fromNow();
            if (this.gridPowerChartOption === "watt") {
                this.gridpower_chart = {
                    title: {
                        text: ((moment(this.Time).format("YYYY-MM-DD") !== this.now) ?
                            moment(this.Time).format("YYYY-MM-DD") : "") + "功率/耗用電量",
                    },
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                            label: {
                                backgroundColor: "#6a7985",
                            }
                        }
                    },
                    legend: {
                        data: ["耗用電量", "當前需量"]
                    },
                    dataZoom: [{
                        startValue: moment(item.timestamp).format("YYYY-MM-DD"),
                    }, {
                        type: "inside",
                    }],
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            name: "時間",
                            type: "category",
                            boundaryGap: false,
                            data: _.map(item.GridPower, v => {
                                return moment(v.timestamp).format("HH:mm");
                            }),
                        }
                    ],
                    yAxis: [
                        {
                            name: "度數(kWh)",
                            type: "value",
                        },
                        {
                            name: "功率(W)",
                            type: "value",
                        }
                    ],
                    series: [
                        {
                            name: "耗用電量",
                            type: "line",
                            yAxisIndex: 0,
                            areaStyle: { normal: {} },
                            data: _.map(item.GridPower, v => {
                                return parseFloat((v.kwha - item.GridPower[0].kwha).toFixed(1));
                            }),
                        }, {
                            name: "當前需量",
                            type: "line",
                            yAxisIndex: 1,
                            data: _.map(item.GridPower, v => {
                                return v.watt_a;
                            }),
                        },
                    ]
                };
            } else {
                this.gridpower_chart = {
                    title: {
                        text: ((moment(this.Time).format("YYYY-MM-DD") !== this.now) ?
                            moment(this.Time).format("YYYY-MM-DD") : "") + "電壓/電流",
                    },
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                            label: {
                                backgroundColor: "#6a7985",
                            }
                        }
                    },
                    legend: {
                        data: ["電壓", "電流"]
                    },
                    dataZoom: [{
                        startValue: moment(item.timestamp).format("YYYY-MM-DD"),
                    }, {
                        type: "inside",
                    }],

                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            name: "(kWh",
                            type: "category",
                            boundaryGap: false,
                            data: _.map(item.GridPower, v => {
                                return moment(v.timestamp).format("HH:mm");
                            }),
                        }
                    ],
                    yAxis: [
                        {
                            name: "電壓(V)",
                            type: "value",
                        },
                        {
                            name: "電流(A)",
                            type: "value",
                        }
                    ],
                    series: [
                        {
                            name: "電壓",
                            type: "line",
                            yAxisIndex: 0,
                            data: _.map(item.GridPower, v => {
                                return v.va;
                            }),
                        }, {
                            name: "電流",
                            type: "line",
                            yAxisIndex: 1,
                            data: _.map(item.GridPower, v => {
                                return v.ia;
                            }),
                        },
                    ]
                };
            }
        } else {
            this.realtime.gridpower.kwh = 0;
            this.realtime.gridpower.voltage = 0;
            this.realtime.gridpower.current = 0;
            this.realtime.gridpower.watt = 0;
            this.realtime.datestamp = `無資料`;
            this.gridpower_chart = {};
        }
        // 處理負載
        if (item.Load !== undefined && item.Load.length > 0) {
            item.Load = this.LoProlfieBlance(this.LoProlfieProcess(item.Load)); // _.sortBy(item.Load, "timestamp");
            this.realtime.loadpower.kwh = parseFloat((item.Load[item.Load.length - 1].kwha - item.Load[0].kwha).toFixed(1));
            this.realtime.loadpower.voltage = item.Load[item.Load.length - 1].va;
            this.realtime.loadpower.current = item.Load[item.Load.length - 1].ia;
            this.realtime.loadpower.watt = item.Load[item.Load.length - 1].watt_a;
            if (this.LoadPowerChartOption === "watt") {
                this.loadpower_chart = {
                    title: {
                        text: ((moment(this.Time).format("YYYY-MM-DD") !== this.now) ?
                            moment(this.Time).format("YYYY-MM-DD") : "") + "功率/耗用電量",
                    },
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                            label: {
                                backgroundColor: "#6a7985",
                            }
                        }
                    },
                    legend: {
                        data: ["耗用電量", "當前需量"]
                    },
                    dataZoom: [{
                        startValue: moment(item.timestamp).format("YYYY-MM-DD"),
                    }, {
                        type: "inside",
                    }],

                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            name: "時間",
                            type: "category",
                            boundaryGap: false,
                            data: _.map(item.GridPower, v => {
                                return moment(v.timestamp).format("HH:mm");
                            }),
                        }
                    ],
                    yAxis: [
                        {
                            name: "度數(kWh)",
                            type: "value",
                        },
                        {
                            name: "功率(W)",
                            type: "value",
                        }
                    ],
                    series: [
                        {
                            name: "耗用電量",
                            type: "line",
                            yAxisIndex: 0,
                            areaStyle: { normal: {} },
                            data: _.map(item.Load, v => {
                                return parseFloat((v.kwha - item.Load[0].kwha).toFixed(1));
                            }),
                        }, {
                            name: "當前需量",
                            type: "line",
                            yAxisIndex: 1,
                            data: _.map(item.Load, v => {
                                return v.watt_a;
                            }),
                        },
                    ]
                };
            } else {
                this.loadpower_chart = {
                    title: {
                        text: ((moment(this.Time).format("YYYY-MM-DD") !== this.now) ?
                            moment(this.Time).format("YYYY-MM-DD") : "") + "電壓/電流"
                    },
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                            label: {
                                backgroundColor: "#6a7985",
                            }
                        }
                    },
                    legend: {
                        data: ["電壓", "電流"]
                    },
                    dataZoom: [{
                        startValue: moment(item.timestamp).format("YYYY-MM-DD")
                    }, {
                        type: "inside",
                    }],

                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            name: "時間",
                            type: "category",
                            boundaryGap: false,
                            data: _.map(item.GridPower, v => {
                                return moment(v.timestamp).format("HH:mm");
                            })
                        }
                    ],
                    yAxis: [
                        {
                            name: "電壓(V)",
                            type: "value",
                        },
                        {
                            name: "電流(A)",
                            type: "value",
                        }
                    ],
                    series: [
                        {
                            name: "電壓",
                            type: "line",
                            yAxisIndex: 0,
                            data: _.map(item.Load, v => {
                                return v.va;
                            })
                        }, {
                            name: "電流",
                            type: "line",
                            yAxisIndex: 1,
                            data: _.map(item.Load, v => {
                                return v.ia;
                            })
                        },
                    ]
                };
            }
        } else {
            this.realtime.loadpower.kwh = 0;
            this.realtime.loadpower.voltage = 0;
            this.realtime.loadpower.current = 0;
            this.realtime.loadpower.watt = 0;
            this.loadpower_chart = {};
        }
        // 處理電池
        if (item.Battery !== undefined && item.Load.length > 0) {
            item.Battery = _.sortBy(item.Battery, "timestamp");
            this.realtime.battery.soc = item.Battery[item.Battery.length - 1].soc;
            this.realtime.battery.voltage = item.Battery[item.Battery.length - 1].voltage;
            this.realtime.battery.charge_current = item.Battery[item.Battery.length - 1].charging_current;
            this.realtime.battery.discharge_current = item.Battery[item.Battery.length - 1].discharging_current;
            this.realtime.battery.charge_watt =
                (item.Battery[item.Battery.length - 1].voltage * item.Battery[item.Battery.length - 1].charging_current);
            this.realtime.battery.discharge_watt =
                (item.Battery[item.Battery.length - 1].voltage * item.Battery[item.Battery.length - 1].discharging_current);
            if (this.BatteryOption === "voltage") {
                this.battery_chart = {
                    title: {
                        text: ((moment(this.Time).format("YYYY-MM-DD") !== this.now) ?
                            moment(this.Time).format("YYYY-MM-DD") : "") + "電池 電壓/電流資料",
                    },
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                            label: {
                                backgroundColor: "#6a7985"
                            }
                        }
                    },
                    legend: {
                        data: ["電壓", "充電電流", "放電電流"]
                    },
                    dataZoom: [{
                        startValue: moment(item.timestamp).format("YYYY-MM-DD")
                    }, {
                        type: "inside",
                    }],
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            type: "category",
                            boundaryGap: false,
                            data: _.map(item.Load, v => {
                                return moment(v.timestamp).format("HH:mm");
                            }),
                        }
                    ],
                    yAxis: [
                        {
                            name: "電壓(V)",
                            type: "value",
                        },
                        {
                            name: "電流(A)",
                            type: "value",
                        }
                    ],
                    series: [
                        {
                            name: "電壓",
                            yAxisIndex: 0,
                            type: "line",
                            data: _.map(item.Battery, v => {
                                return parseFloat((v.voltage).toFixed(1));
                            })
                        }
                        , {
                            name: "充電電流",
                            yAxisIndex: 1,
                            type: "line",
                            data: _.map(item.Battery, v => {
                                return parseFloat((v.charging_current).toFixed(1));
                            }),
                        }
                        , {
                            name: "放電電流",
                            yAxisIndex: 1,
                            type: "line",
                            data: _.map(item.Battery, v => {
                                return parseFloat((v.discharging_current).toFixed(1));
                            }),
                        },
                    ]
                };
            } else {
                this.battery_chart = {
                    title: {
                        text: ((moment(this.Time).format("YYYY-MM-DD") !== this.now) ?
                            moment(this.Time).format("YYYY-MM-DD") : "") + "電池 可用容量/功率資料",
                    },
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                            label: {
                                backgroundColor: "#6a7985"
                            }
                        }
                    },
                    legend: {
                        data: ["可用容量", "充電功率", "放電功率"]
                    },
                    dataZoom: [{
                        startValue: moment(item.timestamp).format("YYYY-MM-DD")
                    }, {
                        type: "inside"
                    }],
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: "category",
                            boundaryGap: false,
                            data: _.map(item.Load, v => {
                                return moment(v.timestamp).format("HH:mm");
                            }),
                        }
                    ],
                    yAxis: [
                        {
                            name: "容量(%)",
                            type: "value",
                            max: 100,
                            min: 0,
                        },
                        {
                            name: "功率(W)",
                            type: "value",
                        }
                    ],
                    series: [
                        {
                            name: "可用容量",
                            yAxisIndex: 0,
                            type: "line",
                            areaStyle: { normal: {} },
                            data: _.map(item.Battery, v => {
                                return parseFloat((v.soc).toFixed(1));
                            })
                        }
                        , {
                            name: "充電功率",
                            yAxisIndex: 1,
                            type: "line",
                            data: _.map(item.Battery, v => {
                                return parseFloat((v.charging_current * v.voltage).toFixed(1));
                            })
                        }
                        , {
                            name: "放電功率",
                            yAxisIndex: 1,
                            type: "line",
                            data: _.map(item.Battery, v => {
                                return parseFloat((v.discharging_current * v.voltage).toFixed(1));
                            })
                        }
                    ]
                };
            }
        } else {
            this.realtime.battery.soc = 0;
            this.realtime.battery.voltage =  0;
            this.realtime.battery.charge_current =  0;
            this.realtime.battery.discharge_current =  0;
            this.realtime.battery.charge_watt = 0;
            this.realtime.battery.discharge_watt = 0;
            this.battery_chart = {};
        }
        // 處理發電機
        if (item.Generator !== undefined && item.Generator.length > 0) {
            item.Generator = _.sortBy(item.Generator, "timestamp");
            this.realtime.generator = item.Generator[item.Generator.length - 1].totalwatts;
            this.generator_chart = {
                title: {
                    text: ((moment(this.Time).format("YYYY-MM-DD") !== this.now) ?
                        moment(this.Time).format("YYYY-MM-DD") : "") + "發電機資料",
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#6a7985"
                        }
                    }
                },
                legend: {
                    data: ["電壓", "電流"]
                },
                dataZoom: [{
                    startValue: moment(item.timestamp).format("YYYY-MM-DD")
                }, {
                    type: "inside"
                }],

                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        boundaryGap: false,
                        data: _.map(item.Generator, v => {
                            return moment(v.timestamp).format("HH:mm");
                        })
                    }
                ],
                yAxis: [
                    {
                        name: "電壓(V)",
                        type: "value",
                        // max: 80
                    },
                    {
                        name: "電流(mA)",
                        // nameLocation: "start",
                        // max: 5,
                        type: "value",
                        // inverse: true
                    }
                ],
                series: [
                    {
                        name: "電壓",
                        yAxisIndex: 0,
                        type: "line",
                        areaStyle: { normal: {} },
                        data: _.map(item.Generator, v => {
                            return v.l1nvoltage;
                        })
                    }
                    , {
                        name: "電流",
                        yAxisIndex: 1,
                        type: "line",
                        areaStyle: { normal: {} },
                        data: _.map(item.Generator, v => {
                            return v.l1current;
                        })
                    }
                ]
            };

        } else {
            this.realtime.generator = 0;
            this.generator_chart = {};
        }
        // 處理個別原始資料
        if (this.rawdata !== undefined && this.rawdata.length > 0) {
            this.realtime.AvailabilityEnergy = (this.realtime.battery.soc * 20 / 100);
            this.realtime.AvailabilityHour = this.realtime.AvailabilityEnergy / (this.realtime.loadpower.watt / 1000);
            this.realtime.datestamp = moment(this.rawdata[0].updateTime).fromNow();
        }
        // end
    }
    private LoProlfieBlance(data: any[]) {
        /**
         * 2018/10/4 KuoFu Wu v1.0. for this
         */
        data = _.orderBy(data, "timestamp");
        if (data !== undefined && data.length > 0) {
            for (let i = 1; i < data.length; i++) {
                if (data[i].kwha <= data[i - 1].kwha) {
                    data[i].kwha = data[i - 1].kwha;
                }
            }
        }
        return data;
    }
    private LoProlfieProcess(data: any[]) {
        // 針對累算型的資料做一次處理
        data = _.orderBy(data, "timestamp");
        if (data !== undefined && data.length > 0) {
            for (let i = 1; i < data.length; i++) {
                data[i].kwha = data[i].kwha - data[0].kwha;
                data[i].kwht = data[i].kwht - data[0].kwht;
            }
            data[0].kwht = 0;
            data[0].kwha = 0;
        }
        return data;
    }
}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/component/energy-storage-detail/energy-storage-detail.component.ts